import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ServicesService } from '../services.service';
// import { JwtHelperService } from '@auth0/angular-jwt';
// import { HttpClientModule } from '@angular/common/http';
// import { HttpModule } from '@angular/http';



@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private _services: ServicesService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    if (localStorage.getItem('userToken') != null && localStorage.getItem('userData') != null) {
        return true;
    }else {
        this.router.navigate(['login']);
        return false;
    }
      // const token = localStorage.getItem('userToken');
      // // Check whether the token is expired and return
      // // true or false
      // console.log('this.jwtHelper.isTokenExpired(token)', this.jwtHelper.isTokenExpired(token));
      // return !this.jwtHelper.isTokenExpired(token);

  }
}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/auth/auth.guard.ts